/**
 * Safely formats the teacher's response text.
 * @param text The raw response text to format.
 * @returns The formatted text or the original text if formatting fails.
 */
export function formatTeacherResponseText(text: string): string {
  if (!text) {
    return '';
  }

  try {
    const parsed = JSON.parse(text);
    if (typeof parsed === 'object' && parsed !== null && 'answer' in parsed) {
      return parsed.answer || '';
    }
    // Parsed object does not contain an "answer" property.
    return text;
  } catch (error) {
    return text;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/utils/text-utils.ts